import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Input class=\"form-field__input\" placeholder={{this.placeholder}} disabled={{this.disabled}} readonly={{this.readonly}} @type=\"tel\" />", {
  moduleName: "@dashboard/shared-ui/components/sq-field-input-phone.hbs"
});